/**
 * This is a product of the TTS engine, generated by reading from the available speech api.
 * It returns a mapped object of voices <TTSControls> can use.
 * @param {Array} voices - array of available voices in rsSpeechAPI
 * @returns {Array} - an array of objects with value and label properties set to the voiceURI and name of the voices
 */
export const getVoiceMap = (voices) => {
  return voices?.map((voice) => {
    return {
      value: voice.voiceURI,
      label: voice.name,
    };
  });
};

export default getVoiceMap;
